import { AxiosResponse } from "axios";

import { ResponseDTO, SupportDTO } from "types";
import { post, get } from "utils";

const baseUrl = `${process.env.REACT_APP_API_URL}/support`;

export const createSupport = async (
  title: string,
  content: string,
  titleImage?: File | null,
  contentImage?: File | null
): Promise<AxiosResponse<ResponseDTO<SupportDTO>>> => {
  let url = `${baseUrl}/create`;

  const formData = new FormData();
  formData.append("title", title);
  formData.append("content", content);
  if (titleImage) {
    formData.append("titleImage", titleImage);
  }
  if (contentImage) {
    formData.append("contentImage", contentImage);
  }

  return post(url, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getMySupportList = async (): Promise<
  AxiosResponse<ResponseDTO<SupportDTO[]>>
> => {
  return get(`${baseUrl}/my-list`);
};

export const submitReport = async (
  targetType: string,
  targetId: string,
  reason: string,
  detail?: string
): Promise<AxiosResponse<ResponseDTO<{ success: boolean }>>> => {
  return post(`${baseUrl}/report`, {
    targetType,
    targetId,
    reason,
    detail,
  });
};

export const getReportList = async (
  page: number,
  limit: number
): Promise<AxiosResponse<ResponseDTO<{ items: any[]; total: number }>>> => {
  return get(`${baseUrl}/report/list?page=${page}&limit=${limit}`);
};

export const resolveReport = async (
  reportId: string
): Promise<AxiosResponse<ResponseDTO<{ success: boolean }>>> => {
  return post(`${baseUrl}/report/resolve`, { reportId });
};

